import SettingsContent from "page_components/client/settings/Content";
import SettingsProvider from "context/settings";

const Settings = () => (
  <SettingsProvider>
    <SettingsContent />
  </SettingsProvider>
);

export default Settings;
